var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.2148 19.5358C15.2775 19.5358 19.3815 15.4318 19.3815 10.3691C19.3815 5.30653 15.2775 1.20247 10.2148 1.20247C5.15223 1.20247 1.04818 5.30653 1.04818 10.3691C1.04818 15.4318 5.15223 19.5358 10.2148 19.5358ZM10.2148 20.3691C15.7377 20.3691 20.2148 15.892 20.2148 10.3691C20.2148 4.84629 15.7377 0.369141 10.2148 0.369141C4.692 0.369141 0.214844 4.84629 0.214844 10.3691C0.214844 15.892 4.692 20.3691 10.2148 20.3691Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "10.2147", cy: "10.3685", r: "8.33333", fill: "#FD6144" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.6944 7.18705C15.0012 7.47423 15.0172 7.95578 14.73 8.26263L10.0502 13.2631C9.76299 13.5699 9.28144 13.5859 8.97459 13.2987L6.19658 10.6988C5.88973 10.4116 5.87378 9.93003 6.16096 9.62318C6.44813 9.31633 6.92969 9.30038 7.23654 9.58756L9.45895 11.6675L13.6188 7.22267C13.906 6.91582 14.3875 6.89987 14.6944 7.18705Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }